import type {ReactElement} from 'react';
import React from 'react';
import type { ControlledListItem3} from '@Components/controlled-list/controlled-list.types';
import {CONTROLLED_LIST_ITEM_TYPE, ControlledListItemSize} from '@Components/controlled-list/controlled-list.types';
import type {Brands} from '@Components/editor-brands/editor-brands.types';
import {ControlledList} from '@Components/controlled-list';
import {useAppSelector} from '@/hooks';

interface BrandsListProps {
  size?: ControlledListItemSize;
  onClick(brandId: string): void;
}

export function BrandsList({size = ControlledListItemSize.SMALL, ...props}: BrandsListProps): ReactElement | null {
  const brands: Array<Brands> = useAppSelector((state) => {
    return state.brands.brands;
  });
  const activeBrandId: string = useAppSelector((state) => {
    return state.brands.activeBrandId ?? '';
  });

  const getListItems = (): Array<ControlledListItem3> => {
    return brands.map((brand) => {
      return {
        id: brand.brandId,
        text: brand.name,
        isSelected: brand.brandId === activeBrandId,
        type: CONTROLLED_LIST_ITEM_TYPE.DEFAULT_3,
        listSize: size,
        onClick: (): void => {
          props.onClick(brand.brandId);
        },
      };
    });
  };

  return <ControlledList scrollIntoViewIfSelected items={getListItems()} className="spacing-m-0" />;
}
